import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'timezoneContainer',
    'selectedTimezone',
    'searchBar',
    'formInput', // the value for order_config_params[:time_zone]
    'abbrInput',
    'timezoneLongForm',
    'timezoneLongFormParent',
    'searchResultsContainer',
    'searchResults',
    'hiddenOptions'
  ]

  connect() {
    feather.replace()
    this.loadTimezoneOptions()
    this.loadTimezoneOptions(true)
    $(this.searchResultsContainerTarget).addClass("hidden")
    this.searchBarTarget.value = ""
  }

  loadTimezoneOptions(fillSearchResults = false) {
    let $select = null;
    if (fillSearchResults) {
      $select = this.searchResultsTarget
    } else {
      $select = this.timezoneContainerTarget
    }

    var timeZones = Array.from(this.hiddenOptionsTarget.children[0].children)
    timeZones.forEach(function(timezone) {
      let option = document.createElement("div");
      let timezoneValue = timezone.value.replace(/&amp;/, "&")
      if (fillSearchResults) {
        option.value = timezoneValue;
      }

      // apply option attrs
      option.setAttribute('place-name', timezone.innerHTML.replace(/&amp;/, "&"))
      option.setAttribute('data-action', 'click->timezones#selectTimeZone');
      option.setAttribute('class', 'py-1 cursor-pointer')

      let timezoneAbbrSpan = document.createElement('span');
      timezoneAbbrSpan.setAttribute('class', 'font-bold')
      timezoneAbbrSpan.innerHTML = `${timezone.value.split(",")[0]}, `
      option.appendChild(timezoneAbbrSpan)
      option.appendChild(document.createTextNode(timezone.innerHTML.replace(/&amp;/, "&")))
  
      // set utc offset
      let utcOffset = document.createElement('span')
      utcOffset.setAttribute('class', 'bg-white px-2 rounded-lg text-xs p-1')
      if (fillSearchResults) {
        utcOffset.setAttribute('style', 'float: right; background: #FFFFFF')
      } else {
        utcOffset.setAttribute('style', 'float: right; background: #F8F8F8')
      }
      utcOffset.innerHTML = `UTC(${timezone.value.split(",")[2].trim()})`
      option.appendChild(utcOffset)

      let skipTimezone = false
      for (let i = 0; i < $select.children.length; i++) {
        if ($select.children[i].value === timezoneValue) {
          skipTimezone = true;
        }
      }

      // finally, apply the option
      if (!skipTimezone) {
        $select.appendChild(option)
      }
    })
  }

  findTimezone(event) {
    let searchTerm = event.target.value.toLowerCase()
    this.loadTimezoneOptions(true)
    let opts = this.searchResultsTarget

    let opt = null
    if (searchTerm == '') {
      $(this.timezoneContainerTarget).removeClass("opacity-20")
      $(this.searchResultsContainerTarget).addClass("hidden")
      this.loadTimezoneOptions(true)
    } else {
      $(this.timezoneContainerTarget).addClass("opacity-20")
      $(this.searchResultsContainerTarget).removeClass("hidden")      
      for (let i=opts.childElementCount-1; i>=0; i--) {
        opt = opts.children[i];
        if (opt.value.toLowerCase().indexOf(searchTerm) == -1) {
          opts.removeChild(opt)
        }
      }
      if (opts.childElementCount == 0) {
        console.log("No results found")
        let option = document.createElement("div");
        option.value = "noResultsMessage"
        let searchResultsMessage = document.createElement('span');
        searchResultsMessage.innerHTML = `We could not find any results under '${event.target.value}'. Please clear your search and try again.`
        option.appendChild(searchResultsMessage)
        opts.appendChild(option)
      } else {
        for (let i=opts.childElementCount-1; i>=0; i--) {
          opt = opts.children[i];
          if (opt.value === "noResultsMessage") {
            opts.removeChild(opt)
          }
        }
      }
    }
  }

  selectTimeZone(event) {
    let element = event.target
    let count = 0
    const maxChain = 2
    let placeNameHTML = null
    let placeName = null
    
    while (element && count <= maxChain) {
      if (element.hasAttribute('place-name')) {
        placeName = element
        placeNameHTML = element.innerHTML
        break;
      }
      element = element.parentElement;
      count++;
    }

    let selectedTimezone = $("#selectedTimezone");
    selectedTimezone.html(placeNameHTML);
    if (placeName) {
        selectedTimezone.attr('place-name', placeName.getAttribute('place-name'));
    }
    // let option = event.target
    // option.removeChild(option.lastChild)

    $(this.element)
    .find('.btn-submit')
    .toggleClass('disabled', false)
    .attr('disabled', false)
  }

  updateTimezoneParent() {
    let option = document.getElementById("selectedTimezone")
    let clonedOption = option.cloneNode(true)
    clonedOption.setAttribute("id", null)
    $(clonedOption).css('background', '')
    $(clonedOption).removeClass("p-2 mb-1")
    clonedOption.removeChild(clonedOption.lastChild)

    $("#selectedTimezoneParent").html(clonedOption);
    $($("#selectedTimezoneParent")[0].parentNode).css('background', '')
    $($("#selectedTimezoneParent")[0].parentNode).removeClass("p-2 px-3")

    this.formInputTarget.value = clonedOption.getAttribute('place-name')

    $(this.element)
    .find('.btn-submit')
    .toggleClass('disabled', true)
    .attr('disabled', true)
  }

  clearSearch() {
    this.searchBarTarget.value = "";
    $(this.timezoneContainerTarget).removeClass("opacity-20")
    $(this.searchResultsContainerTarget).addClass("hidden")
    this.loadTimezoneOptions(true);
  }
}